module.exports = __webpack_public_path__ + "img/feature-03.50ab0ad7.png";